import { signedFetch } from './client';

interface SignedResponse {
  status: number;
  data: unknown;
}

export async function listStores(params?: { limit?: number; nextToken?: string; status?: string }): Promise<SignedResponse> {
  const query = new URLSearchParams();
  if (params?.limit) query.set('limit', String(params.limit));
  if (params?.nextToken) query.set('nextToken', params.nextToken);
  if (params?.status) query.set('status', params.status);
  const qs = query.toString();
  return signedFetch('GET', `/stores${qs ? `?${qs}` : ''}`);
}

export interface CreateStoreInput {
  name: string;
  domain: string;
  streamKey?: { fields: string[]; delimiter?: string };
  deletionProtection?: boolean;
}

export async function createStore(input: CreateStoreInput): Promise<SignedResponse> {
  return signedFetch('POST', '/stores', input);
}

export async function describeStore(name: string): Promise<SignedResponse> {
  return signedFetch('GET', `/stores/${name}`);
}

export async function updateStore(name: string, updates: Partial<Omit<CreateStoreInput, 'name'>>): Promise<SignedResponse> {
  return signedFetch('PUT', `/stores/${name}`, updates);
}

export async function deleteStore(name: string): Promise<SignedResponse> {
  return signedFetch('DELETE', `/stores/${name}`);
}

export async function listViews(): Promise<SignedResponse> {
  return signedFetch('GET', '/views');
}

export async function describeView(name: string): Promise<SignedResponse> {
  return signedFetch('GET', `/views/${name}`);
}

export async function getViewEvents(name: string, params?: { stream?: string; limit?: number }): Promise<SignedResponse> {
  const query = new URLSearchParams();
  if (params?.stream) query.set('stream', params.stream);
  if (params?.limit) query.set('limit', String(params.limit));
  const qs = query.toString();
  return signedFetch('GET', `/views/${name}/events${qs ? `?${qs}` : ''}`);
}

export async function generateQueryFromPrompt(prompt: string, stores: string[]): Promise<SignedResponse> {
  return signedFetch('POST', '/query/generate', { prompt, stores });
}
